<template>
  <div class="page-main page-btns">
    <page-title />
    {{ amount }} <el-button @click="handle">lingqu</el-button>
  </div>
</template>

<script>
import SearchDateTime from "@/components/SearchDate/SearchDateTime.vue";
import { tatList } from "@/api/expenseMansgement";
export default {
  components: {
    SearchDateTime,
  },
  data() {
    return {
      amount: 0,
      contractAirdrop: undefined,
      contractAirdropAddress: undefined,
    };
  },
  created() {},
  mounted() {
    this.getAbiData();
  },
  methods: {
    getAbiData() {
      this.getAbi("Airdrop").then((res) => {
        this.contractAirdrop = new web3.eth.Contract(
          res.data.abi,
          "0x6E2C2999D3448FBF8c75Bf7dfDB5E7D6f19CF93b"
        );
        console.log(this.contractAirdrop);
        // contractAirdropAddress.value = res.result.address;
        this.contractAirdropAddress = "0x6E2C2999D3448FBF8c75Bf7dfDB5E7D6f19CF93b";
        this.queryDepositBalance();
      });
    },
    async queryDepositBalance() {
      try {
        const res = await this.contractAirdrop.methods["claimable"]().call({
          from: this.$store.getters.metaMaskObj.account,
        });
        this.amount = res[1];
      } catch (e) {
        console.log(e);
      }
    },
    handle() {
      const tx_builder = this.contractAirdrop.methods["claim"]();
      const encoded_tx = tx_builder.encodeABI();
      let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractAirdropAddress,
          value: 0,
          data: encoded_tx,
        };
      console.log(json);
      console.log(web3);
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          console.log(res);
          // ElMessage({
          //   message: "successfully!",
          //   type: "success",
          // });
          flag.value = true;
        })
        .catch((error) => {
          console.log(error);
          // ElMessage({
          //   message: "error!",
          //   type: "error",
          // });
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
